module.exports = __webpack_public_path__ + "static/media/room-system.e386e921.svg";